/* Wine & Gold theme — vanilla JS, no build step required */
(function () {

  /* =========================================================
     Money formatting — respects the store's real money format
     (set on window.themeMoneyFormat from layout/theme.liquid)
     instead of hard-coding a currency symbol.
     ========================================================= */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || window.themeMoneyFormat || '₹{{amount}}';

    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }
  window.themeFormatMoney = formatMoney;

  document.addEventListener('DOMContentLoaded', function () {

    /* ---------- Mobile nav ---------- */
    var menuToggle = document.querySelector('[data-menu-toggle]');
    var siteNav = document.querySelector('[data-site-nav]');
    if (menuToggle && siteNav) {
      menuToggle.addEventListener('click', function () {
        var isOpen = siteNav.classList.toggle('is-open');
        menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
      siteNav.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          siteNav.classList.remove('is-open');
          menuToggle.setAttribute('aria-expanded', 'false');
        });
      });
    }

    /* ---------- Header search toggle ---------- */
    var searchToggle = document.querySelector('[data-search-toggle]');
    var searchPanel = document.querySelector('[data-search-panel]');
    if (searchToggle && searchPanel) {
      searchToggle.addEventListener('click', function () {
        var isOpen = searchPanel.classList.toggle('is-open');
        searchToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (isOpen) {
          var input = searchPanel.querySelector('input[type="search"]');
          if (input) input.focus();
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && searchPanel.classList.contains('is-open')) {
          searchPanel.classList.remove('is-open');
          searchToggle.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('click', function (e) {
        if (!searchPanel.classList.contains('is-open')) return;
        if (searchPanel.contains(e.target) || searchToggle.contains(e.target)) return;
        searchPanel.classList.remove('is-open');
        searchToggle.setAttribute('aria-expanded', 'false');
      });
    }

    /* ---------- Header account menu (signed-in state) ---------- */
    var accountToggle = document.querySelector('[data-account-toggle]');
    var accountPanel = document.querySelector('[data-account-panel]');
    if (accountToggle && accountPanel) {
      accountToggle.addEventListener('click', function () {
        var isOpen = accountPanel.classList.toggle('is-open');
        accountToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && accountPanel.classList.contains('is-open')) {
          accountPanel.classList.remove('is-open');
          accountToggle.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('click', function (e) {
        if (!accountPanel.classList.contains('is-open')) return;
        if (accountPanel.contains(e.target) || accountToggle.contains(e.target)) return;
        accountPanel.classList.remove('is-open');
        accountToggle.setAttribute('aria-expanded', 'false');
      });
    }

    /* ---------- Collection sort ---------- */
    var sortSelect = document.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    /* ---------- Product gallery ---------- */
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var mainImg = gallery.querySelector('[data-gallery-main] img');
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          if (mainImg) mainImg.src = thumb.getAttribute('data-full') || thumb.querySelector('img').src;
        });
      });
    });

    /* ---------- Variant swatches / size pills ---------- */
    document.querySelectorAll('[data-option-value]').forEach(function (el) {
      el.addEventListener('click', function () {
        if (el.hasAttribute('disabled')) return;
        var group = el.closest('[data-option-group]');
        group.querySelectorAll('[data-option-value]').forEach(function (o) { o.classList.remove('is-selected'); });
        el.classList.add('is-selected');
        var labelTarget = group.querySelector('[data-option-selected]');
        if (labelTarget) labelTarget.textContent = el.getAttribute('data-value');
        updateVariantId();
      });
    });

    function updateVariantId() {
      var form = document.querySelector('[data-product-form]');
      if (!form || !window.__productVariants) return;

      // Build the selected-options array by position, not by object key order,
      // so it lines up reliably with each variant's own `options` array.
      var groups = Array.prototype.slice.call(form.querySelectorAll('[data-option-group]'));
      var maxIndex = groups.reduce(function (max, g) {
        return Math.max(max, parseInt(g.getAttribute('data-option-index') || '0', 10));
      }, 0);
      var selected = new Array(maxIndex + 1).fill(null);
      groups.forEach(function (group) {
        var picked = group.querySelector('.is-selected');
        var index = parseInt(group.getAttribute('data-option-index') || '0', 10);
        if (picked) selected[index] = picked.getAttribute('data-value');
      });

      var match = window.__productVariants.find(function (v) {
        return v.options.every(function (val, i) { return selected[i] === null || val === selected[i]; });
      });

      var input = form.querySelector('[name="id"]');
      var priceEl = document.querySelector('[data-price-now]');
      var comparePriceEl = document.querySelector('[data-price-compare]');
      var addBtn = form.querySelector('[data-add-to-cart]');
      if (match && input) {
        input.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        if (comparePriceEl) comparePriceEl.textContent = match.compare_at_price ? formatMoney(match.compare_at_price) : '';
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? addBtn.getAttribute('data-label-instock') : addBtn.getAttribute('data-label-oos');
        }
      } else if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.getAttribute('data-label-oos');
      }
    }

    /* ---------- Qty stepper ---------- */
    document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
      var input = stepper.querySelector('input');
      var minus = stepper.querySelector('[data-qty-minus]');
      var plus = stepper.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', function () {
        input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
      });
      if (plus) plus.addEventListener('click', function () {
        input.value = parseInt(input.value || '1', 10) + 1;
      });
    });

    /* ---------- Pincode checker ----------
       Validates the format and shows the store's general shipping policy.
       This does not verify real-time serviceability for the exact pincode —
       connect a courier/delivery API here if you need per-pincode accuracy. */
    document.querySelectorAll('[data-pincode-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var val = form.querySelector('input').value.trim();
        var result = form.querySelector('[data-pincode-result]');
        if (!/^\d{6}$/.test(val)) {
          result.textContent = 'Please enter a valid 6-digit pincode.';
          return;
        }
        var message = form.getAttribute('data-pincode-message') ||
          'We deliver across India. Check the Shipping & returns section below for estimated timelines.';
        result.textContent = message;
      });
    });

    /* ---------- Add to cart (AJAX) ---------- */
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var submitter = e.submitter;
        // "Buy it now" should go straight to checkout, not into the drawer.
        if (submitter && submitter.name === 'checkout') {
          var buyForm = document.createElement('form');
          buyForm.method = 'post';
          buyForm.action = '/cart/add';
          new FormData(form).forEach(function (value, key) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = value;
            buyForm.appendChild(input);
          });
          var redirectInput = document.createElement('input');
          redirectInput.type = 'hidden';
          redirectInput.name = 'return_to';
          redirectInput.value = '/checkout';
          buyForm.appendChild(redirectInput);
          document.body.appendChild(buyForm);
          buyForm.submit();
          return;
        }
        var formData = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) { window.location.href = '/cart'; return Promise.reject(); }
            return fetch('/cart.js');
          })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            renderCartDrawer(cart);
            openCartDrawer();
          })
          .catch(function () { /* already handled or redirected above */ });
      });
    });

    /* ---------- Cart drawer ---------- */
    var drawer = document.querySelector('[data-cart-drawer]');
    var overlay = document.querySelector('[data-cart-overlay]');

    function openCartDrawer() {
      if (drawer) drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
    }
    function closeCartDrawer() {
      if (drawer) drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
    }
    document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); openCartDrawer(); });
    });
    document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', closeCartDrawer);
    });
    if (overlay) overlay.addEventListener('click', closeCartDrawer);

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str == null ? '' : String(str);
      return div.innerHTML;
    }

    function renderCartDrawer(cart) {
      var itemsWrap = document.querySelector('[data-cart-items]');
      var countEls = document.querySelectorAll('[data-cart-count]');
      var subtotalEl = document.querySelector('[data-cart-subtotal]');
      countEls.forEach(function (el) { el.textContent = cart.item_count; });
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      if (!itemsWrap) return;
      itemsWrap.innerHTML = '';
      if (!cart.items.length) {
        var empty = document.createElement('p');
        empty.style.cssText = 'color:var(--ink-soft);font-size:.9rem;';
        empty.textContent = 'Your bag is empty — time to add some sparkle.';
        itemsWrap.appendChild(empty);
        return;
      }
      cart.items.forEach(function (item) {
        var line = document.createElement('div');
        line.className = 'cart-line';
        line.innerHTML =
          '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" width="76" height="86" loading="lazy">' +
          '<div><p style="margin:0 0 .3em;font-size:.9rem;">' + escapeHtml(item.product_title) + '</p>' +
          '<p style="margin:0;font-size:.78rem;color:var(--ink-soft);">' + escapeHtml(item.variant_title || '') + ' · Qty ' + item.quantity + '</p>' +
          '<p style="margin:.3em 0 0;font-size:.85rem;">' + formatMoney(item.final_line_price) + '</p></div>';
        itemsWrap.appendChild(line);
      });
    }

    /* =========================================================
       Wishlist — lightweight, no app required.
       Stored per-browser in localStorage; survives reloads on
       this device but is not synced to the customer's account.
       ========================================================= */
    var WISHLIST_KEY = 'wishlist_items';

    function getWishlist() {
      try {
        return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
      } catch (e) {
        return [];
      }
    }
    function saveWishlist(items) {
      try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(items)); } catch (e) { /* storage unavailable */ }
    }
    function isWished(handle) {
      return getWishlist().some(function (i) { return i.handle === handle; });
    }
    function refreshWishlistUI() {
      var count = getWishlist().length;
      document.querySelectorAll('[data-wishlist-count]').forEach(function (el) { el.textContent = count; });
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
        var handle = btn.getAttribute('data-product-handle');
        btn.classList.toggle('is-active', isWished(handle));
        btn.setAttribute('aria-pressed', isWished(handle) ? 'true' : 'false');
      });
    }
    function renderWishlistDrawer() {
      var wrap = document.querySelector('[data-wishlist-items]');
      if (!wrap) return;
      var items = getWishlist();
      wrap.innerHTML = '';
      if (!items.length) {
        var empty = document.createElement('p');
        empty.style.cssText = 'color:var(--ink-soft);font-size:.9rem;';
        empty.textContent = 'Nothing saved yet — tap the heart on any product to add it here.';
        wrap.appendChild(empty);
        return;
      }
      items.forEach(function (item) {
        var line = document.createElement('div');
        line.className = 'cart-line';
        line.innerHTML =
          '<a href="' + item.url + '" style="flex-shrink:0;"><img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" width="76" height="86" loading="lazy"></a>' +
          '<div style="flex:1;"><a href="' + item.url + '"><p style="margin:0 0 .3em;font-size:.9rem;">' + escapeHtml(item.title) + '</p></a>' +
          '<p style="margin:0;font-size:.85rem;">' + (item.price || '') + '</p>' +
          '<button type="button" class="section__link" data-wishlist-remove="' + escapeHtml(item.handle) + '" style="margin-top:.4em;background:none;border:0;padding:0;cursor:pointer;">Remove</button></div>';
        wrap.appendChild(line);
      });
    }

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-wishlist-toggle]');
      if (toggle) {
        e.preventDefault();
        var handle = toggle.getAttribute('data-product-handle');
        var items = getWishlist();
        var existingIndex = items.findIndex(function (i) { return i.handle === handle; });
        if (existingIndex > -1) {
          items.splice(existingIndex, 1);
        } else {
          items.push({
            handle: handle,
            title: toggle.getAttribute('data-product-title') || '',
            url: toggle.getAttribute('data-product-url') || '#',
            image: toggle.getAttribute('data-product-image') || '',
            price: toggle.getAttribute('data-product-price') || ''
          });
        }
        saveWishlist(items);
        refreshWishlistUI();
        renderWishlistDrawer();
        return;
      }
      var remove = e.target.closest('[data-wishlist-remove]');
      if (remove) {
        var h = remove.getAttribute('data-wishlist-remove');
        saveWishlist(getWishlist().filter(function (i) { return i.handle !== h; }));
        refreshWishlistUI();
        renderWishlistDrawer();
      }
    });

    var wishDrawer = document.querySelector('[data-wishlist-drawer]');
    var wishOverlay = document.querySelector('[data-wishlist-overlay]');
    document.querySelectorAll('[data-wishlist-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        renderWishlistDrawer();
        if (wishDrawer) wishDrawer.classList.add('is-open');
        if (wishOverlay) wishOverlay.classList.add('is-open');
      });
    });
    document.querySelectorAll('[data-wishlist-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (wishDrawer) wishDrawer.classList.remove('is-open');
        if (wishOverlay) wishOverlay.classList.remove('is-open');
      });
    });
    if (wishOverlay) wishOverlay.addEventListener('click', function () {
      wishDrawer.classList.remove('is-open');
      wishOverlay.classList.remove('is-open');
    });

    refreshWishlistUI();
  });
})();
